var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerspective02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.00001L16 19M10 4.00001L10 20M3 12H21M3 5.98918L3 18.0108C3 19.3749 3 20.0569 3.28134 20.5296C3.52803 20.9441 3.9162 21.2555 4.37434 21.4064C4.89685 21.5785 5.56262 21.4305 6.89418 21.1346L18.4942 18.5569C19.3883 18.3582 19.8354 18.2588 20.1691 18.0184C20.4634 17.8063 20.6945 17.5182 20.8377 17.1849C21 16.807 21 16.349 21 15.4331V8.56696C21 7.65102 21 7.19306 20.8377 6.81514C20.6945 6.4818 20.4634 6.19367 20.1691 5.98162C19.8354 5.7412 19.3883 5.64185 18.4942 5.44316L6.89418 2.86538C5.56262 2.56948 4.89685 2.42153 4.37434 2.59362C3.9162 2.74451 3.52803 3.0559 3.28134 3.47039C3 3.94312 3 4.62514 3 5.98918Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspective02);
export default __webpack_public_path__ + "static/media/perspective-02.6f89219aa5bfc63e4ab439c0709d1baa.svg";
export { ForwardRef as ReactComponent };